<template>
  <div class="wrapper">
  <div class="fond">
    <div class="bg-left"></div>
    <div class="bg-right"></div>
  </div>
  <div class="contenair">
    <img class="logo" src="/logo.svg">
    <div class="formulaire">
      <div class="form-left">
        <h1>Merci de votre<br />participation</h1>
        <p>La validation du<br />formulaire est terminée</p>
      </div>
      <div class="form-right">

      </div>     
    </div>
  </div>
  </div>
</template>
<script>
var consts = require('../config');
import axios from "axios";

export default {
  name: "form",
  data: function () {
    return {
      step: 0,
      form_id: consts.FORM_ID,
      server: consts.SERVER_URL,
    };
  },
  methods: {
    loading(value) {
      if (value === true) {
        this.$swal({
          allowOutsideClick: false,
          title: 'Envoi en cours',
          html: 'Merci de bien vouloir patienter ...',
          timerProgressBar: true,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
      }
    },
    checkStep(checkStep) {
       this.step = checkStep++
    },
    getResult(result) {
      if (result._id) {
        this.$swal.close()
        this.$router.push("/done");
      } else {
        alert('Erreur interne')
      }
    },
  },
  mounted() {
  },
  created: function () {}
} 
</script>